import styles from "../../styles/playerEcosystem.module.css";

/**
 * Personal bests strip.
 * @param {{ bests: Array<{ id: string, label: string, value: string, detail?: string }> }} props
 */
export default function PersonalBestsGrid({ bests }) {
  if (!bests?.length) {
    return <p className={styles.muted}>Personal bests appear after you complete matches with scores.</p>;
  }
  return (
    <div className={styles.bestsGrid} aria-label="Personal bests">
      {bests.map((b) => (
        <article key={b.id} className={styles.bestCard}>
          <p className={styles.statLabel}>{b.label}</p>
          <p className={styles.statValue}>{b.value}</p>
          {b.detail ? <p className={styles.muted}>{b.detail}</p> : null}
        </article>
      ))}
    </div>
  );
}
